import { create } from "zustand";
import { SowAdmState, SowAdmContext } from "./sowAdmContext.types";

export const INITIAL_SOW_STATE: SowAdmState = {
  sows: [],
  sowProfile: null,
};

export const useSowAdmContext = create<SowAdmContext>((commit) => ({
  ...INITIAL_SOW_STATE,

  getSows(sows) {
    commit((state) => ({
      ...state,
      sows,
    }));
  },

  getSowProfile(sowProfile) {
    commit((state) => ({
      ...state,
      sowProfile,
    }));
  },

  clearDetails() {
    commit((state) => ({
      ...state,
      activityItemSelected: null,
      activityItemDetails: null,
    }));
  },
}));
